/* eslint-disable react/prop-types */
import React from 'react';

import { createStyles, Table, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const styles = (_theme: Theme) =>
  createStyles({
    tableFixedWidth: {
      tableLayout: 'fixed',
    },
  });

const useStyles = makeStyles(styles);

interface NkTableProps {
  children: React.ReactNodeArray | React.ReactNode;
}

const NkTable = ({ children }: NkTableProps) => {
  const classes = useStyles();

  return <Table className={classes.tableFixedWidth}>{children}</Table>;
};

export default NkTable;
